import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContentLayoutComponent } from "./layouts/content/content-layout.component";
import { CONTENT_ROUTES } from "./shared/routes/content-layout.routes";

const appRoutes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  { path: '', component: ContentLayoutComponent, data: { title: 'Content Views' }, children: CONTENT_ROUTES }
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes)],
  exports: [RouterModule]
})

export class AppRoutingModule {
}
